import React, { useState } from 'react';
import cx from 'classnames';
import RadioButtonsProps from './ButtonGroup.types';
import styles from './ButtonGroup.module.scss';
import Icon from '../Icon';
import Button from '../Button';

const ButtonGroup = ({
  label,
  options,
  onChange,
  dataPointer,
  dataCy = 'buttonGroup',
  trackingLabelPrefix = null,
  invalid,
  errorMsgHolderId,
  icons,
  columns = 0,
  opacity = 'default',
}: RadioButtonsProps) => {
  const [selectedElement, setSelectedElement] = useState<string>('');

  const DELAY: number = 300;
  const DEFAULT_ICON_NAME: string = 'star'; // The icon to use if one is not provided

  const delayOnClick = (e: React.MouseEvent) => {
    setSelectedElement(e.currentTarget.id);

    const changeEvtParams = {
      dataPointer: e.currentTarget.getAttribute('data-pointer'),
      value: e.currentTarget.getAttribute('value'),
    };

    setTimeout(() => {
      onChange(changeEvtParams);
    }, DELAY);
  };

  return (
    <div
      className={cx(styles.buttonGroup, {
        [styles.expanded]: columns,
      })}
      aria-invalid={invalid}
      aria-errormessage={errorMsgHolderId}>
      {options.map((option, index) => {
        const identifier = `${dataPointer}${index}`;
        const value = option.const || option;
        let iconName = DEFAULT_ICON_NAME;
        if (icons && icons[value]) {
          iconName = icons[value];
        }

        return (
          <div key={identifier}>
            <Button
              variant='icon'
              dataCy={dataCy}
              name={label}
              id={identifier}
              value={value}
              onClick={delayOnClick}
              className={cx(styles.button, {
                [styles.translucentButton]: opacity === 'translucent',
              })}
              data-pointer={dataPointer}
              trackingLabel={`${trackingLabelPrefix}${dataPointer}-${value}`}>
              {identifier === selectedElement ? (
                <span aria-hidden className={styles.selectedTick}>
                  <Icon icon='check' height='15px' width='15px' viewBox='0 0 1024 1024' fill='#fff' />
                </span>
              ) : null}
              <span className={styles.buttonImage} aria-hidden>
                <Icon icon={iconName} height='100' width='100' viewBox='0 0 100 100' />
              </span>
              <span className={styles.buttonText}>{option.title || option}</span>
            </Button>
          </div>
        );
      })}
    </div>
  );
};

export default ButtonGroup;
